import { useEffect, useState } from "react";

const WORKING_EVENT = "teammate-working";

export function announceWorkingTeammate(id: string | null) {
  window.dispatchEvent(new CustomEvent<string | null>(WORKING_EVENT, { detail: id }));
}

export function useWorkingTeammate(): string | null {
  const [workingId, setWorkingId] = useState<string | null>(null);

  useEffect(() => {
    const handle = (event: Event) => setWorkingId((event as CustomEvent<string | null>).detail);
    window.addEventListener(WORKING_EVENT, handle);
    return () => window.removeEventListener(WORKING_EVENT, handle);
  }, []);

  return workingId;
}
